import React, { useContext } from "react";
import Cookies from "js-cookie";
import {
  Container,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Heading,
  Box,
  Button,
  Stack,
  useToast,
  Link,
  Text,
} from "@chakra-ui/react";
import { UserContext } from "../context/UserContext";
import axios from "axios";
import { useHistory } from "react-router-dom";

const Login = () => {
  const { user, setLoginStatus, setUser } = useContext(UserContext);
  const toast = useToast();
  const history = useHistory();

  const submitLogin = (event) => {
    event.preventDefault();
    let email = event.target[0].value;
    let password = event.target[1].value;

    axios
      .post(`https://backendexample.sanbersy.com/api/user-login`, {
        email: email,
        password: password,
      })
      .then((res) => {
        let data = res.data;
        setUser({
          name: data.user.name,
          email: data.user.email,
          token: data.token,
        });
        setLoginStatus(true);
        Cookies.set("username", data.user.name, { expires: 1 });
        Cookies.set("password", password, { expires: 1 });
        Cookies.set("token", data.token, { expires: 1 });
        event.target[0].value = "";
        event.target[1].value = "";
        toast({
          title: "Login success",
          description: `Welcome, ${data.user.name}`,
          position: "top",
          status: "success",
          duration: 3000,
        });
        history.push("/");
      });
  };

  return (
    <Box bg="gray.700" color="teal.200" p={24}>
      <Container>
        <Stack spacing="1rem">
          <Heading>Login</Heading>
          <Text>
            New user?
            <Link href="/register"> Register here</Link>
          </Text>
          <form onSubmit={submitLogin}>
            <Stack spacing="1.75rem">
              <FormControl id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input
                  type="email"
                  aria-label="email address"
                  autoComplete="off"
                  name="email"
                />
                <FormHelperText>
                  Please provide your registered email.
                </FormHelperText>
              </FormControl>
              <FormControl id="password" isRequired>
                <FormLabel>Type your password</FormLabel>
                <Input
                  type="password"
                  aria-label="password"
                  autoComplete="off"
                  name="password"
                />
                <FormHelperText>
                  Password should be 8 characters long
                </FormHelperText>
              </FormControl>
              <Button type="submit" colorScheme="teal" variant="solid">
                Login
              </Button>
            </Stack>
          </form>
        </Stack>
      </Container>
    </Box>
  );
};

export default Login;
